module.exports = __webpack_public_path__ + "img/54.365f5a73.svg";